import { Component, OnInit, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterModule } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

// import { WidgetTellBudgetComponent } from './components/widgets/widget-tell-budget/widget-tell-budget.component';
import { ReferralService } from './service/referral.service';
import { TrafficSourceService } from './service/traffic-source.service';
import { environment } from '../environments/environment';
import { SeoService } from './service/seo/seo.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    RouterModule,
    // WidgetTellBudgetComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  isBrowser: boolean = false;
  isStaging = (environment as any).staging === true;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private referralService: ReferralService,
    private trafficSource: TrafficSourceService,
    private seo: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.referralService.initReferralID();
    this.trafficSource.initTrafficSource();
  }
}
